// extracted by mini-css-extract-plugin
export default {"list":"styles_list__07j7j","listItem":"styles_listItem__IPWH9"};